export const COPY_TIMEOUT = 1000;
